import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout'

Vue.use(Router)

export const asyncRoutes = [
  /** when your routing map is too long, you can split it into small modules **/
  // 404 page must be placed at the end !!!
  {path: '*', redirect: '/404', hidden: true}
]

export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login'),
    hidden: true
  },
  {
    path: '/',
    name: 'Main',
    component: Layout,
    redirect: 'dashboard',
    meta: {
      title: '',
      icon: 'home'
    },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard'),
        meta: {
          title: '主页',
          icon: 'menu'
        }
      }
    ]
  },
  {
    path: '/device-management',
    name: 'DeviceManagement',
    component: Layout,
    meta: {
      title: '设备管理',
      icon: 'seal',
      roles: ['超级管理员', '系统管理员']
    },
    children: [
      {
        path: 'seal-list',
        name: 'SealList',
        component: () => import('@/views/device-management/seal-list'),
        meta: {
          title: '印章列表'
        }
      },
      {
        path: 'seal-detail',
        name: 'SealDetail',
        component: () => import('@/views/device-management/seal-detail'),
        meta: {
          title: '印章详情',
          back: true
        },
        hidden: true
      },
      {
        path: 'device-list',
        name: 'DeviceList',
        component: () => import('@/views/device-management/device-list'),
        meta: {
          title: '设备列表'
        }
      },
      {
        path: 'recharge',
        name: 'Recharge',
        component: () => import('@/views/device-management/recharge'),
        meta: {
          title: '充值缴费'
        }
      },
    ]
  },
  {
    path: '/apply',
    name: 'Apply',
    component: Layout,
    redirect: 'apply',
    meta: {
      title: '用印管理',
      icon: 'setting'
    },
    children: [
      {
        path: 'my',
        name: 'MyApply',
        component: () => import('@/views/apply/my'),
        meta: {
          title: '我的申请'
        }
      },
      {
        path: 'approval',
        name: 'ApprovalApply',
        component: () => import('@/views/apply/approval'),
        meta: {
          title: '我的审批'
        }
      },
      {
        path: 'list',
        name: 'ApplyList',
        component: () => import('@/views/apply/stamp'),
        meta: {
          title: '我要用印'
        }
      },

      {
        path: 'apply-detail',
        name: 'ApplyDetail',
        component: () => import('@/views/apply/detail'),
        meta: {
          title: '申请详情',
          back: true
        },
        hidden: true
      },
      {
        path: 'add',
        name: 'ApplyAdd',
        component: () => import('@/views/apply/add'),
        meta: {
          title: '申请用印',
          back: true
        },
        hidden: true
      }
    ]
  },
  {
    path: '/stamp',
    name: 'Stamp',
    component: () => import('@/views/stamp'),
    meta: {
      title: '单据用印',
      hidden: true
    },
    hidden: true
  },
  {
    path: '/company-management',
    name: 'CompanyManagement',
    component: Layout,
    meta: {
      title: '企业管理',
      icon: 'company',
      roles: ['超级管理员', '系统管理员', '印章管理员']
    },
    children: [
      {
        path: 'organization-list',
        name: 'OrganizationList',
        component: () => import('@/views/company-management/organization-management'),
        meta: {
          title: '组织架构',
          roles: ['超级管理员', '系统管理员', '印章管理员']
        }
      },
      {
        path: 'permission-management',
        name: 'PermissionManagement',
        component: () => import('@/views/company-management/permission-management'),
        meta: {
          title: '权限管理',
          roles: ['超级管理员', '系统管理员']
        }
      },
      {
        path: 'set',
        name: 'ProcessSet',
        component: () => import('@/views/company-management/approval-process'),
        meta: {
          title: '审批流程',
          roles: ['超级管理员', '系统管理员']
        }
      },
      {
        path: 'add',
        name: 'ProcessAdd',
        component: () => import('@/views/company-management/approval-process/add'),
        meta: {
          title: '审批流程',
          roles: ['超级管理员', '系统管理员'],
          back: true
        },
        hidden: true
      },
      {
        path: 'electronicfence-management',
        name: 'ElectronicfenceManagement',
        component: () => import('@/views/company-management/electronicfence-management'),
        meta: {
          title: '电子围栏',
          roles: ['超级管理员', '系统管理员']
        }
      },
      {
        path: 'invoice-management',
        name: 'InvoiceManagement',
        component: () => import('@/views/company-management/invoice-management'),
        meta: {
          title: '发票管理',
          roles: ['超级管理员', '系统管理员']
        }
      },
      {
        path: 'invoice-title-management',
        name: 'InvoiceTitleManagement',
        component: () => import('@/views/company-management/invoice-title-management'),
        meta: {
          title: '发票抬头',
          roles: ['超级管理员', '系统管理员']
        },
        hidden: true
      }
    ]
  },
  {
    path: '/stamp-record-management',
    name: 'StampRecordManagement',
    component: Layout,
    meta: {
      title: '用印记录',
      icon: 'list'
    },
    children: [
      {
        path: 'stamp-record',
        name: 'StampRecord',
        component: () => import('@/views/stamp-record-management/stamp-record'),
        meta: {
          title: '用印记录'
        }
      },
      {
        path: 'stamp-record-detail',
        name: 'StampRecordDetail',
        component: () => import('@/views/stamp-record-management/stamp-record/detail'),
        meta: {
          title: '用印记录详情',
          back: true
        },
        hidden: true
      },
      {
        path: 'stamp-record-detail-admin',
        name: 'StampRecordDetailAdmin',
        component: () => import('@/views/stamp-record-management/stamp-record/detail-admin'),
        meta: {
          title: '用印记录详情',
          back: true
        },
        hidden: true
      },
      {
        path: 'alarm-list',
        name: 'AlarmList',
        component: () => import('@/views/stamp-record-management/alarm-management'),
        meta: {
          title: '告警记录'
        }
      },
      {
        path: 'alarm-detail',
        name: 'AlarmDetail',
        component: () => import('@/views/stamp-record-management/alarm-management/detail'),
        meta: {
          title: '告警详情',
          back: true
        },
        hidden: true
      }
    ]
  },
]

const createRouter = () => new Router({
  scrollBehavior: () => ({y: 0}),
  routes: constantRoutes,
  // 增加base
  base: process.env.VUE_APP_PUBLISH_Path
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
